import { selectAccountChats } from "@/reducers/accountChatsSlice"
import { useAppSelector } from "@/reducers/hooks"
import { useFeatureFlagEnabled } from "posthog-js/react"

export default function useIsReadOnlyMap(chatJid: string): boolean {
  const accountChats = useAppSelector(selectAccountChats)
  const isReadOnlyMapEnabled = useFeatureFlagEnabled("read-only-map")

  return (
    Boolean(isReadOnlyMapEnabled) &&
    accountChats[chatJid]?.groupName === "Shared Drivers"
  )
}
